import { Component } from '@angular/core';
import {
  pageNameToPath,
  ReportsCreditCardTab,
  reportsCreditCardTab, ReportsPages,
  reportsPages
} from "../../models/navigation.model";
import { ActivatedRoute, Router } from "@angular/router";
import { NavigationService } from '../../services/navigation.service';
import { ReportsService } from '../../services/reports.service';
import { DateFilter } from '../../models/date-filter.model';
import { map } from "rxjs/operators";
import { combineLatest, Observable } from "rxjs";
import { CreditCardReport } from "../../models/reports.model";
import { showSnackbar } from "../../../../../common/src/lib/components/snackbar/snackbar.component";
import { MatLegacySnackBar as MatSnackBar } from "@angular/material/legacy-snack-bar";
import { ViewAsService } from '../../services/view-as.service';


@Component({
  selector: 'app-reports-credit-card',
  templateUrl: './reports-credit-card.component.html',
  styleUrls: ['./reports-credit-card.component.scss']
})
export class ReportsCreditCardComponent {

  report$: Observable<CreditCardReport> = this.reportsService.report$ as Observable<CreditCardReport>;
  loading$ = this.reportsService.loading$;
  dateFilter$ = this.reportsService.selectedDateRangeForEvent$;
  readonly$ = this.viewAsService.readonly$;

  tabs = Array.from(reportsCreditCardTab);
  pages = Array.from(reportsPages);

  nav$ = combineLatest([
    this.navigationService.page$,
    this.navigationService.tab$
  ]).pipe(
    map(([page, tab]) => {
      return {
        page,
        tab
      };
    })
  );

  constructor(
    private navigationService: NavigationService,
    private route: ActivatedRoute,
    private router: Router,
    private reportsService: ReportsService,
    private viewAsService: ViewAsService,
    private snackbar: MatSnackBar
  ) { }

  onTabSelected(tab: string) {
    const page = pageNameToPath(tab as ReportsCreditCardTab);
    this.router.navigate([page], {relativeTo: this.route});
  }

  onPageSelected(page: string) {
    const chosenPage = pageNameToPath(page as ReportsPages);
    this.router.navigateByUrl('reports/' + chosenPage);
  }

  selectedRangeChange(event: [Date, Date] | null) {
    this.reportsService.setSelectedDateRange(event ? DateFilter.from(event) : null);
  }

  getSelectedTab(selectedTab: string | null) {
    const tabMapping: Record<string, string> = {
      'Settled': 'creditCardSettled',
      'Pending': 'creditCardPending',
      'Pre-chargebacks': 'creditCardPreChargebacks',
      'Chargebacks': 'creditCardChargebacks',
      'Refunds': 'creditCardRefunds',
      'Surcharge': 'creditCardSurcharge'
    };
    return selectedTab ? tabMapping[selectedTab] || '' : '';
  }
}
